module.exports = __webpack_public_path__ + "img/logo.284bf430.jpg";